<template>
  <div>
    <HeaderMegaposData/>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong>
                Transactions By Branch
              </strong>
            </div>
            <div class="row mt-3">
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">Physical Branch <span class="text-danger">*</span></label>
                  <div>
                    <Multiselect
                      v-model="physical_branch_id"
                      :options="physicalBranches"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">From</label>
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="from_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="new Date(new Date().setFullYear(new Date().getFullYear() - 1))"
                      :max-date="new Date()"
                      @update:model-value="onChangeFromDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">To <span class="text-danger">(Up to 60 days)</span></label>
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="to_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="from_date"
                      :max-date="new Date(new Date(from_date).setDate(new Date(from_date).getDate() + this.totalDaySelect))"
                      @update:model-value="onChangeToDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">Status</label>
                  <div>
                    <Multiselect
                      v-model="status"
                      :options="statusArr"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">Payment Method</label>
                  <div>
                    <Multiselect
                      v-model="payment_method_type"
                      :options="paymentMethodTypes"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">Type</label>
                  <div>
                    <Multiselect
                      v-model="typeSelect"
                      mode="tags"
                      :searchable="true"
                      placeholder="Select type"
                      :options="types"
                      :canClear="false"
                      :filterResults="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-3">
              <div class="text-bold me-3">
                Search
              </div>
              <div style="width: 100%; max-width: 500px;">
                <input
                  class="nosubmit"
                  type="search"
                  id="keyword_search"
                  v-model="searchKeyword"
                  extraClass
                  name="keyword_search"
                  placeholder="Enter Transaction ID, Receipt No, Member ID, Mobile, Channel,..."
                  @keydown.enter="handleSearchEnter"
                />
              </div>
            </div>
            <div class="row mt-4 ps-3">
              <div class="col-lg-9 col-md-9 col-3 d-flex">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                    :disabled="disabled"
                  >
                    Download
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('csv')"
                        href="#"
                      >
                        Export CSV
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('xlsx')"
                        href="#"
                      >
                        Export Excel
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('pdf')"
                        href="#"
                        >Export PDF</a
                      >
                    </li>
                  </ul>
                </div>
                <div style="margin-left: 3vh;">
                  <material-button
                    class="btn-background btn-sm"
                    @click="filterData()"
                    style="width: 162.52px"
                  >
                    Run
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row mt-1 ps-3">
              <div class="col-lg-9 col-md-12 col-12 d-flex justify-content-lg-start align-items-end">
                Count: {{ totalRecords }}
              </div>
              <div class="col-lg-3 col-md-12 col-12 d-flex justify-content-lg-end justify-content-start align-items-end mt-lg-0 mt-2">
                <ShowHideColumn
                  :columns="columns"
                  :changeCheckbox="changeCheckbox"
                  :columnCheckedCache="columnChecked"
                  :key="key"
                />
              </div>
            </div>
            <div class="row mt-3 g-2 pos-summary">
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-subtotal material-icons-round">receipt_long</span>
                  <div class="summary-content">
                    <div class="summary-label">SubTotal</div>
                    <div class="summary-value">{{ summary.sub_total_format || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-service material-icons-round">room_service</span>
                  <div class="summary-content">
                    <div class="summary-label">Service Charge</div>
                    <div class="summary-value">{{ summary.service_charge_amount_format || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-gst material-icons-round">percent</span>
                  <div class="summary-content">
                    <div class="summary-label">GST</div>
                    <div class="summary-value">{{ summary.gst_amount_format || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-discount material-icons-round">sell</span>
                  <div class="summary-content">
                    <div class="summary-label">Discount</div>
                    <div class="summary-value">{{ summary.discount_value_format || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card summary-card-total">
                  <span class="summary-icon icon-total material-icons-round">payments</span>
                  <div class="summary-content">
                    <div class="summary-label">Total</div>
                    <div class="summary-value">{{ summary.total_amount_format || '$ 0.00' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4" style="min-height: 1120px;">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th :class="['text-center', 'font-weight-bolder', 'th-preline', compactWidthFields.includes(item.field) ? 'compact-money-col' : '']" v-if="columnShowed.includes(item.field)">
                                <span
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == (index + 1)
                                      ? ESortDirectionSelect.direction === ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    () => {
                                      !!item.hasSortBy &&
                                        handleChangeSortColumn(index + 1);
                                    }
                                  "
                                >{{ item.label }}</span>
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="posTransactionData.length">
                          <tr
                            v-for="(value, key) in posTransactionData"
                            :key="key"
                          >
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('channel_name')"
                            >
                              {{ value.channel_name }}
                            </td>
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('branch_name')"
                            >
                              {{ value.branch_name }}
                            </td>
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('receipt_no')"
                            >
                              {{ value.receipt_no }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('created_at_format')"
                            >
                              {{ value.created_at_format }}
                            </td>
                            <td
                              class="text-center text-xss compact-money-cell"
                              v-if="columnShowed.includes('sub_total_format')"
                            >
                              {{ value.sub_total_format }}
                            </td>
                            <td
                              class="text-center text-xss compact-money-cell"
                              v-if="columnShowed.includes('service_charge_amount_format')"
                            >
                              {{ value.service_charge_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss compact-money-cell"
                              v-if="columnShowed.includes('gst_amount_format')"
                            >
                              {{ value.gst_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss compact-money-cell"
                              v-if="columnShowed.includes('rounding_format')"
                            >
                              {{ value.rounding_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('discount_label')"
                            >
                              {{ value.discount_label }}
                            </td>
                            <td
                              class="text-center text-xss compact-money-cell"
                              v-if="columnShowed.includes('discount_value_format')"
                            >
                              {{ value.discount_value_format }}
                            </td>
                            <td
                              class="text-center text-xss compact-money-cell"
                              v-if="columnShowed.includes('total_amount_format')"
                            >
                              {{ value.total_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('payment_method')"
                            >
                              {{ value.payment_method }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('transaction_id')"
                            >
                              {{ value.transaction_id }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('updated_at_format')"
                            >
                              {{ value.updated_at_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('status')"
                            >
                              {{ value.status }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('guest')"
                            >
                              {{ value.guest }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('take_away_charge_amount_format')"
                            >
                              {{ value.take_away_charge_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('cess_amount_format')"
                            >
                              {{ value.cess_amount_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('operation_id')"
                            >
                              {{ value.operation_id }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('member_id_format')"
                            >
                              {{ value.member_name == 'Non Member' ? 'Non Member' : value.member_id_format  }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('member_phone_number')"
                            >
                              {{ value.member_phone_number }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('amount_direct_deduct_format')"
                            >
                              {{ value.amount_direct_deduct_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('topup_direct_deduct_format')"
                            >
                              {{ value.topup_direct_deduct_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('bonus_cashback_direct_deduct_format')"
                            >
                              {{ value.bonus_cashback_direct_deduct_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('cashback_earned_format')"
                            >
                              {{ value.cashback_earned_format }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('discount_code')"
                            >
                              {{ value.discount_code }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('voucher_code')"
                            >
                              {{ value.voucher_code }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('foc_remarks')"
                            >
                              {{ value.foc_remarks }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('customer_remark')"
                            >
                              {{ value.customer_remark }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('tag')"
                            >
                              {{ value.tag }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('note')"
                            >
                              {{ value.note }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('table_remarks')"
                            >
                              {{ value.table_remarks }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="29" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select v-model="limit" @change="setLimitPerPage" class="rows-per-page__select">
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/download-transaction-by-branch`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="search_keyword" :value="searchKeyword" />
      <input type="hidden" name="member_id" :value="member_id" />
      <input type="hidden" name="phone_number" :value="member_phone_number" />
      <input type="hidden" name="time_type" :value="time_type" />
      <input type="hidden" name="from_date" :value="dateFormat(from_date)" />
      <input type="hidden" name="to_date" :value="dateFormat(to_date)" />
      <input type="hidden" name="physical_branch_id" :value="physical_branch_id" />
      <input type="hidden" name="status" :value="status" />
      <input v-for="type in typeSelect" :key="type" type="hidden" name="type[]" :value="type" />
      <input type="hidden" name="checkExport" :value="checkExport" />
      <input
        type="hidden"
        name="payment_method_type"
        :value="payment_method_type"
      />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from '@/components/MaterialSnackbar.vue'
import 'bootstrap/dist/js/bootstrap.bundle'
import MaterialLoading from '@/components/MaterialLoading.vue'
import Pagination from '@/components/Pagination.vue'
import 'bootstrap/js/dist/modal'
import '@vuepic/vue-datepicker/dist/main.css'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import MaterialButton from '@/components/MaterialButton.vue'
import ShowHideColumn from '@/components/ShowHideColumnCustom.vue'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import DashboardReportService from '../../services/dashboardReport.service'
import $ from 'jquery'
import TokenService from '../../services/token.service'
import CommonFunctionService from "../../services/commonFunction.service";
import { mergeDeductedBonusCashbackColumns } from "@/config/utils";
import HeaderMegaposData from '../analytics/components/HeaderMegaposData.vue'

export default {
  name: 'TransactionByBranch',
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Multiselect,
    Datepicker,
    ShowHideColumn,
    HeaderMegaposData,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem('MERCHANT_CODE', ''),
      message: '',
      snackbar: null,
      loaderActive: false,
      searchKeyword: '',
      searchTimerId: null,
      pagination: {},
      page: 1,
      columns: [
        { value: 'all', label: 'All' },
        { value: 'channel_name', label: 'Channel' },
        { value: 'branch_name', label: 'Branch' }, // OFF
        { value: 'receipt_no', label: 'Receipt' },
        { value: 'created_at_format', label: 'OrderTime' },
        { value: 'sub_total_format', label: 'SubTotal' },
        { value: 'service_charge_amount_format', label: 'ServiceCharge' },
        { value: 'gst_amount_format', label: 'GST' },
        { value: 'rounding_format', label: 'Rounding' },
        { value: 'discount_label', label: 'DiscountLabel' }, // OFF
        { value: 'discount_value_format', label: 'Discount' },
        { value: 'total_amount_format', label: 'Total' },
        { value: 'payment_method', label: 'Payment' },
        { value: 'transaction_id', label: 'TXN ID' },
        { value: 'updated_at_format', label: 'LastUpdated' },
        { value: 'status', label: 'Status' },
        { value: 'guest', label: 'Guest' },
        { value: 'take_away_charge_amount_format', label: 'TakeAwayCharge' }, // OFF
        { value: 'cess_amount_format', label: 'Cess' }, // OFF
        { value: 'operation_id', label: 'OperationID' },
        { value: 'member_id_format', label: 'MemberID' },
        { value: 'member_phone_number', label: 'MemberMobile' }, // OFF
        { value: 'amount_direct_deduct_format', label: 'DeductedAmount' },
        { value: 'topup_direct_deduct_format', label: 'DeductedTopup' }, // OFF
        { value: 'bonus_cashback_direct_deduct_format', label: 'DeductedCashback/Bonus' }, // OFF
        { value: 'cashback_earned_format', label: 'Redemption' }, // OFF
        { value: 'discount_code', label: 'DiscountCode' }, // OFF
        { value: 'voucher_code', label: 'VoucherCode' },
        { value: 'foc_remarks', label: 'FocRemarks' }, // OFF
        { value: 'customer_remark', label: 'CustomerRemark' }, // OFF
        { value: 'tag', label: 'Tag' }, // OFF
        { value: 'note', label: 'Note' }, // OFF
        { value: 'table_remarks', label: 'TableRemarks' }, // OFF
      ],
      reward_type: 0,
      time_type: 9,
      times: [
        { value: 0, label: 'Select Time' },
        { value: 1, label: 'Today' },
        { value: 2, label: 'Yesterday' },
        { value: 3, label: 'Last 7 days' },
        { value: 4, label: 'Last 30 days' },
        { value: 5, label: 'This month' },
        { value: 6, label: 'Last 3 months' },
        { value: 7, label: 'This year' },
        { value: 8, label: 'Last year' },
        { value: 9, label: 'Custom' },
      ],
      from_date: new Date(),
      to_date: new Date(),
      member_id: null,
      phone_number: '',
      email: '',
      gender: 0,
      isShowTimeCustom: false,
      action: 'list',
      action_export: 'csv',
      totalRecords: 0,
      summary: {},
      columnShowed: [
        'channel_name',
        'receipt_no',
        'created_at_format',
        'sub_total_format',
        'service_charge_amount_format',
        'gst_amount_format',
        'rounding_format',
        'discount_value_format',
        'total_amount_format',
        'payment_method',
        'transaction_id',
        'updated_at_format',
        'status',
        'guest',
        'operation_id',
        'member_id_format',
        'amount_direct_deduct_format',
        'voucher_code',
      ],
      branchs: [],
      physicalBranches: [],
      physical_branch_id: 0,
      branch_id: 0,
      tiers: [],
      tier_id: 0,
      posTransactionData: [],
      vouchers: [],
      paymentMethodTypes: [],
      payment_method_type: 0,
      columnChecked: [],
      checkExport: false,
      statusArr: [],
      status: '',
      ESortDirectionSelect: {
        idx: null,
        direction: null
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      transactionSelect: {},
      typeSelect: [], // default ALL
      types: [
        {
          value: 1,
          label: "Full Bill Paid"
        },
        {
          value: 2,
          label: "Voucher Applied"
        },
        {
          value: 3,
          label: "Discount Applied"
        },
        {
          value: 4,
          label: "Voucher & Discount Applied"
        }
      ],
      totalDaySelect: 60,
      limit: 20,
    }
  },
  created() {
    this.getDataFilter()
    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }

    const cachedColumns = window.localStorage.getItem('TransactionByBranchColumn')
    if (cachedColumns) {
      const parsedColumns = mergeDeductedBonusCashbackColumns(
        cachedColumns.split(',').filter(Boolean),
        'bonus_direct_deduct_format',
        'cashback_direct_deduct_format',
        'bonus_cashback_direct_deduct_format'
      )
      this.columnShowed = parsedColumns
      this.columnChecked = [...parsedColumns]
    } else {
      this.columnChecked = [...this.columnShowed]
      window.localStorage.setItem('TransactionByBranchColumn', this.columnShowed.join(','))
    }

    this.key = Math.random()
  },
  computed: {
    compactWidthFields() {
      return [
        'sub_total_format',
        'service_charge_amount_format',
        'gst_amount_format',
        'rounding_format',
        'discount_value_format',
        'total_amount_format',
      ];
    },
    headersData() {
      return [
        {
          label: "Sales\nChannel",
          field: "channel_name",
          hasSortBy: true,
        },
        {
          label: "Branch",
          field: "branch_name",
        },
        {
          label: "Receipt",
          field: "receipt_no",
          hasSortBy: true,
        },
        {
          label: "Order\nTime",
          field: "created_at_format",
          hasSortBy: true,
        },
        {
          label: "SubTotal",
          field: "sub_total_format",
          hasSortBy: true,
        },
        {
          label: "Service\nCharge",
          field: "service_charge_amount_format",
          hasSortBy: true,
        },
        {
          label: "GST",
          field: "gst_amount_format",
          hasSortBy: true,
        },
        {
          label: "Rounding",
          field: "rounding_format",
          hasSortBy: true,
        },
        {
          label: "Discount\nLabel",
          field: "discount_label",
        },
        {
          label: "Discount",
          field: "discount_value_format",
          hasSortBy: true,
        },
        {
          label: "Total",
          field: "total_amount_format",
          hasSortBy: true,
        },
        {
          label: "Payment",
          field: "payment_method",
          hasSortBy: true,
        },
        {
          label: "TXN ID",
          field: "transaction_id",
          hasSortBy: true,
        },
        {
          label: "Last\nUpdated",
          field: "updated_at_format",
          hasSortBy: true,
        },
        {
          label: "Status",
          field: "status",
          hasSortBy: true,
        },
        {
          label: "Guest",
          field: "guest",
          hasSortBy: true,
        },
        {
          label: "TakeAway\nCharge",
          field: "take_away_charge_amount_format",
          hasSortBy: true,
        },
        {
          label: "Cess",
          field: "cess_amount_format",
          hasSortBy: true,
        },
        {
          label: "Operation ID",
          field: "operation_id",
          hasSortBy: true,
        },
        {
          label: "MemberID",
          field: "member_id_format",
          hasSortBy: true,
        },
        {
          label: "Member\nMobile",
          field: "member_phone_number",
        },
        {
          label: "Deducted\nAmount",
          field: "amount_direct_deduct_format",
          hasSortBy: true,
        },
        {
          label: "Deducted\nTopup",
          field: "topup_direct_deduct_format",
          hasSortBy: true,
        },
        {
          label: "Deducted\nCashback/Bonus",
          field: "bonus_cashback_direct_deduct_format",
        },
        // Was "Deducted Cashback" (merged above). Kept so sortCol indexes still line up with BE SORT_COL_*.
        { label: "", field: null },
        {
          label: "Redemption",
          field: "cashback_earned_format",
          hasSortBy: true,
        },
        {
          label: "Discount\nCode",
          field: "discount_code",
          hasSortBy: true,
        },
        {
          label: "Voucher\nCode",
          field: "voucher_code",
          hasSortBy: true,
        },
        {
          label: "Foc\nRemarks",
          field: "foc_remarks",
        },
        {
          label: "Customer\nRemark",
          field: "customer_remark",
        },
        {
          label: "Tag",
          field: "tag",
        },
        {
          label: "Note",
          field: "note",
        },
        {
          label: "Table\nRemarks",
          field: "table_remarks",
        },
      ];
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date)
    },

    onChangeFromDate(from_date) {
      this.from_date = from_date;
      let limitDate = moment(from_date).add(this.totalDaySelect, 'days');

      if (moment(this.to_date) > limitDate || moment(this.to_date) < moment(this.from_date)) {
        if (limitDate > moment()) {
          limitDate = moment();
        }

        this.to_date = from_date;
      }
    },

    onChangeToDate(to_date) {
      this.to_date = to_date;
    },

    exportFile(type = 'csv') {
      if (this.columnShowed.length == 0) {
        this.snackbar = 'danger'
        this.message = 'You must select least 1 column to export file.'
        this.setTimeOutNotification()
      } else {
        this.action_export = type
        setTimeout(() => {
          $('#downloadForm').click()
        }, 150)
      }
    },

    changeCheckbox(columnShowed) {
      this.columnShowed = columnShowed
      window.localStorage.setItem("TransactionByBranchColumn", columnShowed)
    },

    timeChange($event) {
      if ($event == 9) {
        this.isShowTimeCustom = true
      } else {
        this.isShowTimeCustom = false
      }
    },

    filterData() {
      this.getList(this.page)
    },

    dateFormat(date) {
      if (date == null) {
        return null
      } else {
        return moment(date).format('YYYY-MM-DD')
      }
    },

    closeSnackbar() {
      this.snackbar = null
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null
      }, 3000)
    },

    handleChangeSortColumn(idx) {
      if (this.ESortDirectionSelect.idx && this.ESortDirectionSelect.idx == idx) {
        this.ESortDirectionSelect.direction = this.ESortDirectionSelect.direction === this.ESortDirection.Asc ? this.ESortDirection.Desc : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          direction: this.ESortDirection.Asc
        }
      }

      if (this.posTransactionData.length) {
        this.getList(this.page);
      }
    },

    getList(page) {
      this.vouchers = []
      this.totalRecords = 0
      this.showLoader()
      var dataForm = {
        action: this.action,
        physical_branch_id: this.physical_branch_id,
        search_keyword: this.searchKeyword,
        member_id: this.member_id,
        phone_number: this.phone_number,
        email: this.email,
        time_type: this.time_type,
        from_date: this.dateFormat(this.from_date),
        to_date: this.dateFormat(this.to_date),
        payment_method_type: this.payment_method_type,
        type:  this.typeSelect,
        action_export: this.action_export,
        checkExport: this.checkExport,
        status: this.status,
        page: page,
        sortCol: this.ESortDirectionSelect.idx,
        sortType: this.ESortDirectionSelect.direction,
        limit: this.limit,
      }
      DashboardReportService.getDataTransactionByBranch(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.posTransactionData = response.data.data.items
            this.pagination = response.data.data
            this.page = this.pagination.current_page
            this.totalRecords = this.pagination.total
            this.summary = response.data.data.summary || {}
            if (this.pagination.current_page > this.pagination.last_page) {
              this.page = 1
              this.getList(this.page)
            }
            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            })
            this.checkExport = true;
          } else {
            this.snackbar = 'danger'
            this.message = response.data.result.message
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = error
          this.hideLoader()
          this.setTimeOutNotification()
        },
      )
    },

    setLimitPerPage() {
      // Reset to page 1 when changing limit
      this.page = 1;
      this.getList(1);
    },

    showLoader() {
      this.loaderActive = true
    },

    hideLoader() {
      this.loaderActive = false
    },

    getDataFilter() {
      this.showLoader()
      DashboardReportService.getFilterDataTopupReport().then(
        (response) => {
          if (response.data.result.isSuccess) {
            var DataFilter = response.data.data
            this.physicalBranches = DataFilter.physicalBranches;
            this.paymentMethodTypes = DataFilter.paymentMethods;
            this.statusArr = response.data.data.status;
            if (this.statusArr && typeof this.statusArr === 'object') {
              delete this.statusArr[""];
            }
            this.status = "1";

            this.physicalBranches.shift();
          } else {
            this.snackbar = 'danger'
            this.message = response.data.result.message
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = error
          this.hideLoader()
          this.setTimeOutNotification()
        },
      )
    },

    handleSearchEnter(){
      this.getList(this.page);
    },
  },
}
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: 150px;
}

table thead th.compact-money-col {
  min-width: 45px;
  width: 45px;
}

table tbody td.compact-money-cell {
  min-width: 45px;
  width: 45px;
  white-space: nowrap;
}

table thead th > span {
  position: relative;
}

:deep(.wrapper-sortby) {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding-right: 18px;
}

:deep(.wrapper-sortby::before) {
  top: calc(50% - 1px) !important;
  bottom: auto !important;
  right: 0 !important;
  transform: translateY(-50%);
}

:deep(.wrapper-sortby::after) {
  top: calc(50% + 1px) !important;
  bottom: auto !important;
  right: 0 !important;
  transform: translateY(-50%);
}

.th-preline {
  white-space: nowrap;
}

input[type='search'] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type='search']::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type='search']:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
    padding-top: 7px;
}

/* Summary cards */
.pos-summary .summary-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  height: 100%;
  padding: 16px;
  border: 1px solid #eef0f3;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(20, 45, 82, 0.06);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.pos-summary .summary-card:hover {
  box-shadow: 0 10px 26px rgba(20, 45, 82, 0.1);
  transform: translateY(-2px);
}

.pos-summary .summary-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  font-size: 22px;
}

.pos-summary .icon-subtotal {
  background: linear-gradient(135deg, #4c7ef3, #6f9bff);
}

.pos-summary .icon-service {
  background: linear-gradient(135deg, #e08a3c, #f2b562);
}

.pos-summary .icon-gst {
  background: linear-gradient(135deg, #9b5de5, #c084f5);
}

.pos-summary .icon-discount {
  background: linear-gradient(135deg, #2f9e78, #38b6a0);
}

.pos-summary .icon-total {
  background: linear-gradient(135deg, #1f6f78, #38b6a0);
}

.pos-summary .summary-content {
  min-width: 0;
}

.pos-summary .summary-card-total {
  background: linear-gradient(135deg, #f3f6ff 0%, #eef7f4 100%);
  border-color: #cfe4e0;
}

.pos-summary .summary-label {
  font-size: 11px;
  color: #8392ab;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.3;
  min-height: 30px;
}

.pos-summary .summary-value {
  margin-top: 4px;
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  word-break: break-word;
}
</style>
